<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="37.412" height="51.443" viewBox="0 0 37.412 51.443">
    <g id="Gruppe_101" data-name="Gruppe 101" transform="translate(-157.9 -143.9)">
      <line id="Linie_1" data-name="Linie 1" x2="20" transform="translate(167.212 167.702)" fill="none" stroke="#a8a8a8" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2"/>
      <line id="Linie_3" data-name="Linie 3" x2="20" transform="translate(167.212 183.702)" fill="none" stroke="#a8a8a8" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2"/>
      <line id="Linie_4" data-name="Linie 4" x1="20" transform="translate(167.212 175.702)" fill="none" stroke="#a8a8a8" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2"/>
      <path id="Pfad_38" data-name="Pfad 38" d="M183.659,150.471c-1.258,0-2.128-1.318-2.618-2.686a3.661,3.661,0,0,0-7.109,0c-.49,1.369-1.36,2.686-2.618,2.686H169v5.471a1.7,1.7,0,0,0,1.543,1.824h13.888a1.7,1.7,0,0,0,1.543-1.824v-5.471Z" transform="translate(-0.881 0)" fill="none" stroke="#a8a8a8" stroke-linejoin="round" stroke-width="2.2"/>
      <ellipse id="Ellipse_8" data-name="Ellipse 8" cx="1.5" rx="1.5" transform="translate(175.212 152.702)" fill="none" stroke="#a8a8a8" stroke-linejoin="round" stroke-width="2.2"/>
      <path id="Pfad_39" data-name="Pfad 39" d="M185.828,151H191.7a2.632,2.632,0,0,1,2.515,2.736v38.3a2.632,2.632,0,0,1-2.515,2.736H161.515A2.632,2.632,0,0,1,159,192.036v-38.3A2.632,2.632,0,0,1,161.515,151h5.869" transform="translate(0 -0.529)" fill="none" stroke="#a8a8a8" stroke-linejoin="round" stroke-width="2.2"/>
    </g>
  </svg>
</template>

<script>
export default {
name: "notesLarge"
}
</script>

<style scoped>

</style>